import { useLocalization } from '@/localization';
export function formatWithThousandSeparator(num) {
    return Number(num).toLocaleString('en-US');
}
export const useCompareStrings = () => {
    const { getLocale } = useLocalization();
    const currentLocale = getLocale();
    const collator = new Intl.Collator(currentLocale, {
        sensitivity: 'base',
        numeric: true,
        caseFirst: 'lower',
    });
    return (a, b) => collator.compare(a, b);
};
